export const CHUNK_RELOAD_STORAGE_KEY = "obsidian-ridge:chunk-reload-at";
export const CHUNK_RELOAD_GUARD_MS = 60_000;

let fallbackReloadClaimed = false;

/** Claim the one automatic stale-chunk reload allowed inside the guard window. */
export function claimChunkReload(
  storage: Pick<Storage, "getItem" | "setItem">,
  now = Date.now(),
  guardMs = CHUNK_RELOAD_GUARD_MS
): boolean {
  try {
    const previous = Number(storage.getItem(CHUNK_RELOAD_STORAGE_KEY));
    if (Number.isFinite(previous) && previous > 0 && now - previous < guardMs) {
      return false;
    }
    storage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(now));
    return true;
  } catch {
    // sessionStorage can be unavailable under strict privacy settings. Keep an
    // in-memory guard so those users still receive one recovery attempt.
    if (fallbackReloadClaimed) return false;
    fallbackReloadClaimed = true;
    return true;
  }
}

export function installChunkRecovery(): () => void {
  if (typeof window === "undefined") return () => undefined;

  const handlePreloadError = (event: Event) => {
    if (!claimChunkReload(window.sessionStorage)) return;
    event.preventDefault();
    window.location.reload();
  };

  window.addEventListener("vite:preloadError", handlePreloadError);
  return () => window.removeEventListener("vite:preloadError", handlePreloadError);
}
